import { axios, Response } from '../index'

export interface FileRequest {
  id: string
  fileName: string
  size: number
  uploadedBy: string
  fileType: string
  folderId: string
  fileUrl: string
}

export type CreateFileRequestDTO = {
  fileName: string
  originalFileName: string
  fileSize: number
  fileContentType: string
  folderId: string | null
}

export default async function uploadFiles(
  personId: string,
  data: CreateFileRequestDTO[]
): Response<FileRequest[]> {
  return await axios.post(`/v1/personas/${personId}/files`, data)
}
